import { InventoryLocation } from '../inventory/InventoryLocation'
import { Field, ObjectType, ID, Float, InputType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('ProductCurrentInventoryInput')
export class ProductCurrentInventory {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('pci') })
  _id: string

  @Field(() => InventoryLocation)
  @Prop({ type: InventoryLocation })
  location: InventoryLocation

  @Field(() => Float)
  @Prop({ type: Number })
  quantityOnHand: number

  @Field(() => String)
  @Prop({ type: String })
  unitOfMeasure: string

  @Field(() => Float, { nullable: true })
  @Prop({ type: Number, default: null })
  computedQtyOnHand: number | null

  @Field(() => Float, { nullable: true })
  @Prop({ type: Number, default: null })
  computedRequiredQty: number | null

  @Field(() => Date, { nullable: true })
  @Prop({ type: Date, default: null })
  computedQtyUpdatedAt: Date | null
}
